export default __webpack_public_path__ + "static/bundle2023-2e5a67f597a7d8dee09588aea00234fc.png";